const authenticationResolvers = {};

export default authenticationResolvers;
